import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';

import { withModalActions } from 'core/hocs';
import { FormattedTag, RouteLink } from 'core/components';

import { ModalWindow } from 'components/modal-window/modal-window';
import { IconCross } from 'components/icons/icon-cross/icon-cross';
import { CATEGORIES_ITEMS } from 'components/games-filters/games-categories-icons';

import { MODAL_IDS } from '../../../constants';

import './games-categories-modal.scss';

class GamesCategoriesModalUI extends Component {
  static propTypes = {
    filterCategory: PropTypes.string,
    closeModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    filterCategory: ''
  }

  closeModal = () => {
    const { closeModal } = this.props;
    closeModal(MODAL_IDS.GAMES_CATEGORIES);
  }

  render() {
    const { filterCategory } = this.props;

    return (
      <ModalWindow
        id={MODAL_IDS.GAMES_CATEGORIES}
        coreProps={{ id: MODAL_IDS.GAMES_CATEGORIES }}
        modalClassName="games-categories-modal-parent"
        backdropClassName="games-categories-modal-backdrop"
        bodyClassName="bg-light game-categories-body bg-light"
        isCentered
        fade
      >
        <div className="games-categories-menu mt-1 px-2_75 icon-state-observer ">
          {CATEGORIES_ITEMS.map(({
            Icon, key, to, category
          }) => {
            const isActive = category === filterCategory;

            return (
              <RouteLink
                key={key}
                to={`/games/${to}`}
                className="d-flex flex-column align-items-center"
                onClick={this.closeModal}
              >
                <Icon className={classNames({ active: isActive })} />
                <FormattedTag id={key} className={classNames('text-small text-capitalize font-weight-semi-bold mt-0_75 letter-spacing-default', { 'text-gray-10': !isActive })} />
              </RouteLink>
            );
          })}
        </div>

        <button
          type="button"
          onClick={this.closeModal}
          className="game-caategory-btn-close d-flex align-items-center justify-content-center bg-dark-2 w-100 text-white mt-2 py-1"
        >
          <IconCross />
          <FormattedMessage id="got-it" />
        </button>

      </ModalWindow>
    );
  }
}

export const GamesCategoriesModal = withModalActions(GamesCategoriesModalUI);
